import { Logo } from "./Logo";

const LINKS = [
  { label: "Features", href: "#features", testid: "nav-link-features" },
  { label: "How It Works", href: "#how", testid: "nav-link-how" },
  { label: "Calculator", href: "#calculator", testid: "nav-link-calculator" },
  { label: "Community", href: "#community", testid: "nav-link-community" },
  { label: "FAQ", href: "#faq", testid: "nav-link-faq" },
];

export const scrollToId = (href) => (e) => {
  e.preventDefault();
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -90 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const Navbar = () => (
  <header
    data-testid="navbar"
    className="fixed inset-x-0 top-4 z-50 mx-auto w-[calc(100%-2rem)] max-w-5xl"
  >
    <nav className="flex items-center justify-between gap-4 rounded-full border border-white/10 bg-[#07090E]/80 py-3 pl-4 pr-3 backdrop-blur-xl">
      <a href="#top" onClick={scrollToId("#top")} data-testid="nav-logo-link" className="flex items-center gap-2.5">
        <Logo className="h-8 w-8" />
        <span className="font-display text-lg font-extrabold tracking-[0.18em] text-slate-50">
          FUNZ
        </span>
      </a>
      <div className="hidden items-center gap-7 lg:flex">
        {LINKS.map((l) => (
          <a
            key={l.href}
            href={l.href}
            data-testid={l.testid}
            onClick={scrollToId(l.href)}
            className="text-sm font-medium text-slate-400 transition-colors hover:text-[#A3E635]"
          >
            {l.label}
          </a>
        ))}
      </div>
      <button
        data-testid="nav-cta-button"
        onClick={scrollToId("#claim")}
        className="glow-btn rounded-full bg-[#A3E635] px-5 py-2.5 font-display text-xs font-bold uppercase tracking-wider text-[#07090E]"
      >
        Claim .edu Pass
      </button>
    </nav>
  </header>
);
